
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';  // Full app - testing with updated table names
// import SupabaseTestApp from './SupabaseTestApp.tsx';  // Connection test complete
// import TokenDecoderApp from './TokenDecoderApp.tsx';  // Token analysis complete
// import DatabaseAnalysisApp from './DatabaseAnalysisApp.tsx';  // Schema analysis complete
import './index.css';

// Environment detection and logging (Vite environment variables)
const environment = import.meta.env.VITE_ENV || import.meta.env.MODE || 'development';
const appUrl = import.meta.env.VITE_APP_URL || window.location.origin;
const isDebugMode = import.meta.env.VITE_ENABLE_DEBUG_MODE === 'true';
// Alpha environment specific logging
if (environment === 'alpha') {
  // Enhanced error reporting for alpha
  window.addEventListener('beforeunload', () => {
  });
}

// Add error boundary to catch React errors
window.addEventListener('error', (e) => {
  console.error('🚨 Global JavaScript Error:', e.error);
  console.error('🚨 Error message:', e.message);
  console.error('🚨 Error stack:', e.error?.stack);
});

window.addEventListener('unhandledrejection', (e) => {
  console.error('🚨 Unhandled Promise Rejection:', e.reason);
});

const rootElement = document.getElementById('root');
if (rootElement) {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('🚨 Error rendering React app:', error);
    const errorMessage = error instanceof Error ? error.message : String(error);
    const errorStack = error instanceof Error ? error.stack : '';
    rootElement.innerHTML = `
      <div style="padding: 20px; font-family: Arial;">
        <h1 style="color: red;">React Rendering Error</h1>
        <p>Error: ${errorMessage}</p>
        <pre style="background: #f5f5f5; padding: 10px; overflow: auto;">${errorStack}</pre>
      </div>
    `;
  }
} else {
  console.error('❌ Root element not found!');
  document.body.innerHTML = '<h1 style="color: red;">ERROR: Root element not found!</h1>';
}  